import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { headerStore } from 'apps/components/header/app';

import {
  SearchWrapper,
  SearchButton,
  SearchInput,
  SearchForm,
} from './search.styled';

const Search = props => {
  const { searchTerm, searchIsVisible } = headerStore;

  const ref = useRef(null);

  const onSubmitSearch = event => {
    event.preventDefault();
    if (searchTerm === '') {
      headerStore?.HideSearch();
    } else {
      headerStore?.NavigateToSearchPage();
    }
  };

  const onClickSearch = () => {
    if (searchIsVisible) {
      headerStore?.HideSearch();
      ref?.current?.blur();
    } else {
      headerStore?.ShowSearch();
      ref?.current?.focus();
    }
  };

  const onKeyDownSearch = event => {
    if (event.key === 'Escape') {
      if (searchTerm !== '') {
        headerStore?.ResetSearchTerm();
      } else {
        headerStore?.HideSearch();
      }
    }
  };

  return (
    <SearchWrapper isMobile={props.isMobile} searchIsVisible={searchIsVisible}>
      <SearchForm
        onSubmit={onSubmitSearch}
        inverted={props.inverted}
        variant={props.variant}
      >
        <SearchButton
          outline
          variant='tertiary'
          icon='search'
          ariaLabel='Search'
          name='search-button'
          isDark={props.isDark}
          size={searchIsVisible ? 'small' : 'default'}
          onClick={onClickSearch}
        />
        <SearchInput
          name='search-input'
          type='text'
          ref={ref}
          value={searchTerm}
          inverted={props.inverted}
          variant={props.variant}
          placeholder={props.t('Search Community...')}
          onBlur={() => {
            if (searchTerm === '') headerStore?.HideSearch();
          }}
          onKeyDown={onKeyDownSearch}
          onChange={event => headerStore?.UpdateSearchTerm(event.target.value)}
        />
      </SearchForm>
    </SearchWrapper>
  );
};

Search.defaultProps = {
  isMobile: false,
  isDark: false,
  searchTerm: '',
  variant: 'default',
};

Search.propTypes = {
  variant: PropTypes.string,
  inverted: PropTypes.bool,
  isMobile: PropTypes.bool,
  isDark: PropTypes.bool,
  t: PropTypes.func,
  searchTerm: PropTypes.string,
};

export default withNamespaces()(Search);
